<template>
  <div :key="contact.id">
    <router-view />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    computed: {
        ...mapGetters([
            'contact',
        ]),
    },
    async beforeRouteUpdate(to, from, next) {
        if (from.params.contactId !== to.params.contactId) {
            if (await this.getContactInfo(to.params.contactId)) {
                next();
            }
        } else {
            next();
        }
    },
    methods: {
        ...mapActions({
            getContactInfo: 'getContactInfo',
        }),
    },
};
</script>
